import { render, staticRenderFns } from "./ModalCadastroPeriodoExecucaoAno.vue?vue&type=template&id=3aa66d51"
import script from "./ModalCadastroPeriodoExecucaoAno.vue?vue&type=script&lang=js"
export * from "./ModalCadastroPeriodoExecucaoAno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports